export class ContractTransferModel {
  id: number;
  keycloakClientId: string;
  sentByAdvisorId: string;
  subject: string;
  message: string;
  sentEmailTo: string;
  created: string;
  insuranceProviderId: number;
  insuranceProviderName: string;
  contractId: number;
  contractUid: string;
  clientFirstName: string;
  clientLastName: string;
  clientEmail: string;
  status: 'SENT' | 'CONFIRMED';
  isCollapsed?: boolean;
}

export class ContractTransferRequestModel {
  keycloakClientId: string;
  contractUId: string;
  insuranceProviderId: number;
  subject: string;
  reminder: 'WEEKLY' | 'BI_WEEKLY' | 'MONTHLY' | null;
  message: string;
  status: 'SENT' | 'CONFIRMED';
  sentEmailTo: string;
  ccEmails: string[] = [];
}

export class ContractTransferListRequestModel {
  page: number;
  page_size: number = 25;
  status: 'SENT' | 'CONFIRMED';
  sort_direction: 'ASC' | 'DESC' = 'DESC';
  sort_by: 'created' | 'status' | 'clientFirstName' | 'clientLastName' | 'clientEmail' | 'insuranceProviderName' =
    'created';
}

export class ContractTransferListResponseModel {
  data: ContractTransferModel[];
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
}
